module.exports = __webpack_public_path__ + "static/img/14000071.dabdb3ca.png";